export default {
  getDetail: state => state.detail,
  getNotificationList: state => state.notificationList,
  getCondition: state => state.condition,
  getUnreadCount: state => state.unreadCount
};
